import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import * as api from "../api.js";
import { PageHeader, Loading, ErrorBanner, formatCost } from "../components.jsx";

export default function Tenants() {
  const nav = useNavigate();
  const [state, setState] = useState({ loading: true, error: null });
  const [tenants, setTenants] = useState([]);
  const [costs, setCosts] = useState({});

  useEffect(() => {
    (async () => {
      try {
        const res = await api.listTenants();
        const list = res.data || [];
        setTenants(list);

        const costResults = await Promise.allSettled(
          list.map((t) => api.getCostStatus(t._id))
        );
        const byTenant = {};
        for (let i = 0; i < list.length; i++) {
          if (costResults[i].status === "fulfilled") {
            byTenant[list[i]._id] = costResults[i].value.data;
          }
        }
        setCosts(byTenant);
        setState({ loading: false, error: null });
      } catch (err) {
        setState({ loading: false, error: err });
      }
    })();
  }, []);

  return (
    <>
      <PageHeader
        title="Tenants"
        subtitle={`${tenants.length} tenant${tenants.length === 1 ? "" : "s"} managed`}
        breadcrumbs={[{ label: "Tenants" }]}
        actions={
          <button
            className="btn primary"
            onClick={() => nav("/tenants/new")}
          >
            + New Tenant
          </button>
        }
      />

      <div className="page-body">
      <ErrorBanner error={state.error} />

      {state.loading ? (
        <Loading />
      ) : (
        <div className="card" style={{ padding: 0 }}>
          <table className="table" style={{ border: "none" }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>ID</th>
                <th>Sub-Tenants</th>
                <th>MTD Spend</th>
                <th>Monthly Cap</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {tenants.length === 0 ? (
                <tr>
                  <td colSpan="6" className="table-empty">
                    No tenants yet. Click <strong>+ New Tenant</strong> to launch the setup wizard.
                  </td>
                </tr>
              ) : (
                tenants.map((t) => {
                  const cost = costs[t._id];
                  const monthSpend = cost?.month_to_date?.estimated_cost_usd || 0;
                  const monthlyCap = cost?.caps?.monthly_usd;
                  const pct = monthlyCap ? Math.round((monthSpend / monthlyCap) * 100) : null;
                  return (
                    <tr key={t._id}>
                      <td>
                        <Link to={`/tenants/${t._id}`}>
                          <strong>{t.name}</strong>
                        </Link>
                      </td>
                      <td className="mono">{t._id}</td>
                      <td>{t.sub_tenants?.length || 0}</td>
                      <td>{formatCost(monthSpend)}</td>
                      <td>
                        {monthlyCap ? (
                          <>
                            {formatCost(monthlyCap)}
                            {pct != null && (
                              <span className="muted small" style={{ marginLeft: 6 }}>
                                ({pct}%)
                              </span>
                            )}
                          </>
                        ) : (
                          <span className="subtle">—</span>
                        )}
                      </td>
                      <td>
                        {cost?.is_cost_locked ? (
                          <span className="badge badge-danger">Cost-locked</span>
                        ) : pct >= 80 ? (
                          <span className="badge badge-stale">Warning ({pct}%)</span>
                        ) : (
                          <span className="badge badge-live">Active</span>
                        )}
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      )}
      </div>
    </>
  );
}
